export default __webpack_public_path__ + "3125c30e1b98221a4b4d5f5ea89c62f3.woff";